window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    
    var params = {
      $container: this.$container,
      product: options.product,
      singleOptionSelector: options.singleOptionSelector,
      originalSelectorId: options.originalSelectorId,
      currentVariant: this.currentVariant,
    };
    
    this.swatches = new slate.Swatches(params);

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;
      
      if(document.getElementById(this.currentVariant.id + "_pocontent")){
        var pocontent = document.getElementById(this.currentVariant.id + "_pocontent").value;

        if(document.getElementById("pocontent")){
          document.getElementById("pocontent").innerHTML = pocontent;
        }
      }
      
      document.getElementById("covid-po").style.display = "none";
      if(document.getElementById(this.currentVariant.id + "_pocontent")){
        var pocontent = document.getElementById(this.currentVariant.id + "_pocontent").value;

        if(document.getElementById("pocontent")){
          document.getElementById("pocontent").innerHTML = pocontent;
        }

      }
      if(document.getElementById(this.currentVariant.id + "_pocontent_date")){
        if(document.getElementById(this.currentVariant.id + "_pocontent_date").value.length > 0 ){
          var pocontentdate = document.getElementById(this.currentVariant.id + "_pocontent_date").value;
          document.getElementById("coviddate").innerHTML = pocontentdate;
          document.getElementById("covid-po").style.display = "block";
        }

      }

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/**
 * Swatches Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the swatches inputs in any `cart/add` forms that may
 * exist.
 *
 * @namespace swatches
 */

slate.Swatches = (function() {

  var selectors = {
    swatches: '[data-swatch]',
    swatchOptions: '[data-swatch-option]',
  };

  /**
   * Swatches constructor
   *
   * @param {object} options - Settings from `variants.js`
   */
  function Swatches(params) {
    this.$container = params.$container;
    this.product = params.product;
    this.currentVariant = params.currentVariant;
    this.singleOptionSelector = params.singleOptionSelector;
    this.originalSelectorId = params.originalSelectorId;
    this.variants = this.product.variants;
    this.options = this.product.options;
    this.swatches = $(selectors.swatches);
    this.swatchOptions = this.swatches.find(selectors.swatchOptions);
    this.colorOptionIndex = this.getOptionIndex('color');

    this.hideSwatchesSelects();
    this.defineAvailableColors();
    this.updateVariantMax(this.currentVariant);

    let self = this;
    if (this.colorOptionIndex >= 0) {
      let $filterableSwatches = this.swatches.filter(function(index) {
        return $(self.swatches[index]).data('option-index') != self.colorOptionIndex;
      });
      this.showAvailableOptions(this, $filterableSwatches, this.currentVariant.options[this.colorOptionIndex]);
    } else {
      this.showAvailableOptions(this, this.swatches);
    }

    $(this.swatchOptions, this.$container).on('change', function(){
      let evt = $(this);
      self.switchSwatches.bind(self)(evt);
    });

    $(this.swatchOptions, this.$container).parent().hover(function() {
      let $option = $(this).find(selectors.swatchOptions);

      if ($option.data('swatch-option') == self.colorOptionIndex) {
        let $swatchHolder = $option.closest(selectors.swatches);
        $swatchHolder.find('.header > span').text($swatchHolder.data('swatch')+': '+$option.val());
      }
    }, function() {
      let $option = $(this).find(selectors.swatchOptions);

      if ($option.data('swatch-option') == self.colorOptionIndex && self.currentVariant !== undefined) {
        let $swatchHolder = $option.closest(selectors.swatches);
        $swatchHolder.find('.header > span').text($swatchHolder.data('swatch')+': '+self.currentVariant.options[self.colorOptionIndex]);
      }
    });
  }

  Swatches.prototype = $.extend({}, Swatches.prototype, {

    hideSwatchesSelects: function() {
      let self = this;

      this.swatches.each(function() {
        let $swatch = $(this);
        $(self.singleOptionSelector).eq(self.getOptionIndex($swatch.data('swatch'))).parent().hide();
      });
    },

    /**
     * Show only av
     *
     * @param {object} variant - Currently selected variant
     */
    defineAvailableColors: function() {
      let self = this;

      if (this.colorOptionIndex >= 0) {
        $.each(this.variants, function(i, variant) {
          if (variant.available) {
            let $option = self.swatchOptions.filter('#swatch-'+self.colorOptionIndex+'-'+variant.options[self.colorOptionIndex].toLowerCase());
            self.makeSwatchOptionAvailable($option);
          }
        });
      }
    },

    makeSwatchOptionAvailable: function($option) {
      $option.parent().addClass('available').removeClass('soldout');

      return $option;
    },

    makeSwatchOptionUnavailable: function($option) {
      $option.prop('checked', false).parent().addClass('soldout').removeClass('available');

      return $option;
    },

    getOptionIndex: function(optionName) {
      return this.options.map(v => v.toLowerCase()).indexOf(optionName.toLowerCase());
    },

    getVariantLabels: function(variant) {
      const badgesLists = document.querySelectorAll('.product-badges');
      if(!badgesLists) {
        return;
      }

      badgesLists.forEach((badgesList) => {
        const variantId = badgesList.getAttribute('data-variant-id');

        badgesList.classList.add('hide');
        if(variantId == variant.id) {
          badgesList.classList.remove('hide');
        }
      })
    },

    updateVariantMax: function(variant) {
      const variantQtyMax = jQuery('[data-product-select]').find('[data-variant-qty]:selected').attr('data-variant-qty');
      const variantPolicy = jQuery('[data-product-select]').find('[data-variant-policy]:selected').attr('data-variant-policy');
      const productQty = document.querySelector('.product-qty-input');
      const productQtyVal = productQty.value;

      if ( variantPolicy == 'continue' ) {
        jQuery(productQty).removeAttr('max');
      } else {
        jQuery(productQty).attr('max', variantQtyMax);
        if (productQtyVal > variantQtyMax) {
          jQuery(productQty).attr('value', variantQtyMax);
          jQuery(productQty).val(variantQtyMax);
        }
        setTimeout(jcf.destroyAll(), 100);
        setTimeout(jcf.replaceAll(), 100);
      }
    },

    switchSwatches: function($option) {
      let self = this;
      let swatchIndex = $option.data('swatch-option');
      let $optionSelector = $(this.singleOptionSelector).eq(swatchIndex);
      let optionVal = $option.val();
     

      if ($optionSelector.val() !== optionVal) {
        let $otherSwatches = this.swatches.filter(function(index) {
          return $(self.swatches[index]).data('option-index') != swatchIndex;
        });
        if (swatchIndex != this.colorOptionIndex) {
          let $swatchesWithoutColor = this.swatches.filter(function(index) {
            return $(self.swatches[index]).data('option-index') != self.colorOptionIndex;
          });
          $otherSwatches = $otherSwatches.filter(value => !$swatchesWithoutColor.has(value));
        }

        if ($otherSwatches.length > 0) {
          this.showAvailableOptions(self, $otherSwatches, optionVal, 'switch');
        }

        $optionSelector.val(optionVal);
      }

      $(this.singleOptionSelector).first().trigger('change');
      this.currentVariant = self.variants.filter(function(v) {return v.id == $(self.originalSelectorId).val();})[0];
    },

    showAvailableOptions: function(self, $swatches, optionVal = '', type = 'load') {
      self.makeSwatchOptionUnavailable($swatches.find(selectors.swatchOptions));

      let hasChecked = false;

      $.each(self.variants, function(i, variant) {
        if (self.colorOptionIndex >= 0) {
          if (((variant.options[self.colorOptionIndex] == optionVal) || (optionVal.length === 0 && variant.options[0] == self.currentVariant.options[0])) && variant.available) {
            $.each($swatches, function(i, swatch) {
              let $swatch = $(swatch);
              let currentSwatchIndex = $swatch.data('option-index');
              let $optionSelector = $(self.singleOptionSelector).eq(currentSwatchIndex);
              let $option = $('[data-value="'+variant.options[currentSwatchIndex]+'"]').find(selectors.swatchOptions).first();

              self.makeSwatchOptionAvailable($option);
//alert(self.currentVariant.options[currentSwatchIndex] + '-' + variant.options[currentSwatchIndex]);
              if (type == 'load') {
                
                if (self.currentVariant.options[currentSwatchIndex] == variant.options[currentSwatchIndex]) {
                  $option.prop('checked', true);
                  $optionSelector.val(variant.options[currentSwatchIndex]);
                }
              } else {
                if (self.currentVariant){
                  if (self.currentVariant.options[currentSwatchIndex] == variant.options[currentSwatchIndex]) {
                    $option.prop('checked', true);
                    $optionSelector.val(variant.options[currentSwatchIndex]);
                  }else if (!hasChecked) {
                    $option.prop('checked', true);
                    $optionSelector.val(variant.options[currentSwatchIndex]);
                  }
                }else if (!hasChecked) {
                  $option.prop('checked', true);
                  $optionSelector.val(variant.options[currentSwatchIndex]);
                }
                hasChecked = true;
              }

            });

          }
        } else {
          $.each($swatches, function(i, swatch) {
            let $swatch = $(swatch);
            let currentSwatchIndex = $swatch.data('option-index');
            let $optionSelector = $(self.singleOptionSelector).eq(currentSwatchIndex);
            let $option = $('[data-value="'+variant.options[currentSwatchIndex]+'"]').find(selectors.swatchOptions).first();

            self.makeSwatchOptionAvailable($option);
          });
        }
      });
    },

  });

  return Swatches;
})();




/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productSlider: '[data-product-slider]',
    productThumbnails: '[data-product-thumbnails]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    var self = this;
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

		this.currentVariant 	= this.variants.currentVariant;
		//const currentOptions 	= this.getCurrentVariantOptions(this.currentVariant);

    // main product slider
		this.$slider = this.$container.find(selectors.productSlider);

		if(this.$slider.length){
			this.$slider.slick({
				prevArrow: '<button class="slick-arrow slick-prev" aria-label="Previous"><svg width="28" height="32" viewBox="0 0 28 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 16L5.29289 16.7071L4.58579 16L5.29289 15.2929L6 16ZM14.7071 8.70711L6.70711 16.7071L5.29289 15.2929L13.2929 7.29289L14.7071 8.70711ZM6.70711 15.2929L14.7071 23.2929L13.2929 24.7071L5.29289 16.7071L6.70711 15.2929Z" fill="#2C2C2C"/></svg></button>',
				nextArrow: '<button class="slick-arrow slick-next" aria-label="Next"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 16L22.7071 16.7071L23.4142 16L22.7071 15.2929L22 16ZM13.2929 8.70711L21.2929 16.7071L22.7071 15.2929L14.7071 7.29289L13.2929 8.70711ZM21.2929 15.2929L13.2929 23.2929L14.7071 24.7071L22.7071 16.7071L21.2929 15.2929Z" fill="#2C2C2C"/></svg></button>',
        asNavFor: selectors.productThumbnails,
        lazyLoad: 'ondemand',
        infinite: false,
        responsive: [{
          breakpoint: 767,
          settings: {
            rows: 0,
            dots: true
          }
        }]
			});
		}

		this.$slider.slick("slickSetOption", "swipe", window.innerWidth < 1025);
		$(window).on('resize orientationchange', () => {
			self.$slider.slick("slickSetOption", "swipe", window.innerWidth < 1025);
      self.$slider.slick('resize');
		});

    // thumbnails slider
    this.$thumbnails = this.$container.find(selectors.productThumbnails);

		if(this.$thumbnails.length){
      this.$thumbnails.on('init', function() {
        try {
          self.$thumbnails.slick("slickGoTo", 0, true);
        }
        catch(error) {
            setTimeout(function() {self.$thumbnails.trigger('init');}, 5);
            return;
        }

        self.updateProductSlider.bind(self)();
        self.$thumbnails.addClass('slick-loaded');
        self.$slider.addClass('slick-loaded');
      });
			this.$thumbnails.slick({
        slidesToShow: 5,
        prevArrow: '<button class="slick-arrow slick-prev" aria-label="Previous"><svg width="28" height="32" viewBox="0 0 28 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 16L5.29289 16.7071L4.58579 16L5.29289 15.2929L6 16ZM14.7071 8.70711L6.70711 16.7071L5.29289 15.2929L13.2929 7.29289L14.7071 8.70711ZM6.70711 15.2929L14.7071 23.2929L13.2929 24.7071L5.29289 16.7071L6.70711 15.2929Z" fill="#2C2C2C"/></svg></button>',
        nextArrow: '<button class="slick-arrow slick-next" aria-label="Next"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 16L22.7071 16.7071L23.4142 16L22.7071 15.2929L22 16ZM13.2929 8.70711L21.2929 16.7071L22.7071 15.2929L14.7071 7.29289L13.2929 8.70711ZM21.2929 15.2929L13.2929 23.2929L14.7071 24.7071L22.7071 16.7071L21.2929 15.2929Z" fill="#2C2C2C"/></svg></button>',
        asNavFor: selectors.productSlider,
        focusOnSelect: true,
        infinite: false,
        responsive: [{
          breakpoint: 1023,
          settings: {
            rows: 0,
            slidesToShow: 4
          }
        }]
			});
		}

		this.$thumbnails.slick("slickSetOption", "swipe", window.innerWidth < 1025);
		$(window).on('resize orientationchange', () => {
			self.$thumbnails.slick("slickSetOption", "swipe", window.innerWidth < 1025);
		});

    this.$container.on('variantChange' + this.namespace, this.updateProductSlider.bind(this));
    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Updates the DOM with the specified slides
     */
    updateProductSlider: function(evt) {
      let variant = evt !== undefined ? evt.variant : this.currentVariant;
      let colorOptionIndex = this.productSingleObject.options.map(v => v.toLowerCase()).indexOf('color');
      let color = variant.options[colorOptionIndex];

      this.$slider.slick('slickUnfilter');
      let slider_has_color = $('[data-color="' + color + '"]', self.$slider);
      this.$slider.slick('slickFilter', function () {
        if (slider_has_color === undefined || slider_has_color.length === 0){
          return true;
        }
        return $('[data-color="' + color + '"]', this).length === 1;
      });
      this.$slider.slick('resize');

      this.$thumbnails.slick('slickUnfilter');
      let thumbnails_has_color = $('[data-color="' + color + '"]', self.$thumbnails);
      this.$thumbnails.slick('slickFilter', function () {
        if (thumbnails_has_color === undefined || thumbnails_has_color.length === 0){
          return true;
        }
        return $('[data-color="' + color + '"]', this).length === 1;
      });
      this.$thumbnails.slick('resize');
      var index = 0;
      $.each(this.$thumbnails.find('.slick-slide').not(".slick-cloned"), function (t, v) {
        $(v).attr("data-slick-index", index);
        index++;
      });
    },


    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

theme.Slider = (function ($) {
	function Slider(container) {
		this.$contaner = $(container);
		if (!this.$contaner.length) {
			return;
		}

		let count = this.$contaner.data("slides-count");
		if (count < 2) {
			return;
		}

		let autoplaySpeed = this.$contaner.data("autoplay-speed");

		(() => {
			let slider = this.$contaner.find("#slider");

			if (!slider.length) {
				return;
			}

			slider.slick({
				dots: true,
				dotsClass: "slider__dots",
				infinite: true,
				autoplay: !!autoplaySpeed,
				pauseOnHover: false,
				pauseOnFocus: false,
				pauseOnDotsHover: false,
				waitForAnimate : false,
				prevArrow: $('.js-slider-arrow-prev'),
				nextArrow: $('.js-slider-arrow-next'),
				speed: 650,
				fade: true,
				autoplaySpeed: autoplaySpeed || false,
				cssEase: 'linear',
				responsive: [
					{
						breakpoint: 768,
						settings: {
							appendDots: $(".js-slider-dots")
						}
					}
				]
			});

			slider.on('touchend touchcancel touchmove', function() {
				$(this).slick('slickPlay');
			});

			$(window).on('resize orientationchange', () => {
				slider.slick('resize');
			});

			slider.on('afterChange', function (event, slick, currentSlide) {
				slick.$dots.each((i, el) => {
					$(el).find('li').eq(currentSlide).addClass('slick-active');
				});
			});
		})();
	}

	return Slider;
})(jQuery);



;(function() {
  const swatchList = document.querySelectorAll('[data-variant-image]');
  if(!swatchList) {
    return;
  }

  swatchList.forEach((swatch) => {
    swatch.addEventListener('change', function(){
      const parent = this.closest('.featured-product');
      if(parent) {
        const variantId = this.getAttribute('data-variant-image');
        const images = parent.querySelectorAll('.featured-product__image');

        if(images.length < 2) {
          return;
        }

        images.forEach((image) => {
          image.classList.add('hide');
          const imageVariant = image.getAttribute('data-value');

          if(variantId == imageVariant) {
            image.classList.remove('hide');
          }
        })
      }
    });
  })

  ResponsiveHelper.addRange({
    '767..': {
      on: function() {
        jQuery('.js-featured-slideshow').slick({
          slidesToScroll: 1,
          slidesToShow: 4,
          infinite: false,
          rows: 0,
          responsive: [{
            breakpoint: 1024,
            settings: {
              slidesToScroll: 1,
              slidesToShow: 2
            }
          }]
        });
      },
      off: function() {
        jQuery('.js-featured-slideshow').slick('destroy');
      }
    }
  });

}());


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');
  var addressHeader = $('.address__header');
  var addressButtons = $('.address__btn-wrap');
  var addressList = $('.address__list');
  var countrySelect = $('#AddressCountryNew');
  var countryEDITSelects = $('.address-country-option');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
    addressHeader.toggleClass('hide');
    addressButtons.toggleClass('hide');
    addressList.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');

    addressHeader.toggleClass('hide');
    addressButtons.toggleClass('hide');
    addressList.toggleClass('hide--items');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });

  $(countrySelect).on('change', function() {
    var colProvince = document.querySelector("#AddressProvinceContainerNew");
    var styleProvince = window.getComputedStyle(colProvince).getPropertyValue("display");
    var columns = $('.js-row-province > div');

    if(styleProvince == 'block') {
      columns.each(function() {
        $( this ).removeClass('col-6');
        $( this ).addClass('col-4');
      });
    } else {
      columns.each(function() {
        $( this ).removeClass('col-4');
        $( this ).addClass('col-6');
      });
    }
  });


  countryEDITSelects.each(function() {
    var form = $(this).closest('form');
    var formId = form.find('.form-id').text();
    var selectCountry = form.find('#AddressCountry_' + formId);
    var columnProvince = form.find('#AddressProvinceContainer_' + formId);
    var row = $('.js-row-province-edit');
    var columnsEdit = columnProvince.closest('.js-row-province-edit');
    var columns = $('.js-row-province-edit > div');

    if(columnProvince[0].style.cssText == 'display: none;') {
      columnsEdit.each(function() {
        $( this ).find('div').removeClass('col-4');
        $( this ).find('div').addClass('col-6');
      });
    } else {
      columnsEdit.each(function() {
        $( this ).find('div').removeClass('col-6');
        $( this ).find('div').addClass('col-4');
      });
    }

    $(selectCountry).on('change', function() {
      var colProvince = row.find('#AddressProvinceContainer_' + formId);
      if(colProvince[0].style.cssText == 'display: none;') {
        columns.each(function() {
          $( this ).removeClass('col-4');
          $( this ).addClass('col-6');
        });
      } else {
        columns.each(function() {
          $( this ).removeClass('col-6');
          $( this ).addClass('col-4');
        });
      }
    });
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

/**
 * Register Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Register template.
 *
 * @namespace register
 */

theme.customerRegister = (function() {
  const passwordForm = document.querySelector('.js-form-validate');

  if(!passwordForm) {
    return;
  }
  const registerSubmit = passwordForm.querySelector('#RegisterSubmit');

  function checkPasswords() {
    let passwordField = passwordForm.querySelector('#CreatePassword').value;
    let confirmationPasswordField = passwordForm.querySelector('#CustomerPasswordConfirmation').value;

    if(passwordField === confirmationPasswordField) {
      registerSubmit.removeAttribute('disabled');
    } else {
      registerSubmit.setAttribute('disabled', 'disabled');
    }
  }

  function checkInputs() {
    registerSubmit.setAttribute('disabled', 'disabled');

    passwordForm.addEventListener('input', function () {
      let validFlag = false;
      let registerInputs = passwordForm.querySelectorAll('.js-input');


      for (let i = 0; i < registerInputs.length; i++) {
        if(!registerInputs[i].validity.valid ) {
          validFlag = false;
          return;
        } else {
          validFlag = true;
        }
      }

      if(validFlag === true) {
        checkPasswords();
      }
    }, false);
  }

  checkInputs();
})();

;(function() {
  const challengeWrap = jQuery('.shopify-challenge__container');

  if(challengeWrap){
    $("html, body").animate({ scrollTop: 0 }, "slow");
  }
}());

;(function() {
  const addClass = setTimeout(function(){
    const wishlistEmptyTitle = jQuery('.wk-wishlist-empty-note');

    if(wishlistEmptyTitle){
      $("body").addClass('template-wishlist-empty');
    } else {
      $("body").removeClass('template-wishlist-empty');
    }
    clearTimeout(addClass);
  }, 100);

}());


;(function(){
  inView('.viewport-section, .page__container--legal > *, .viewport-section-rte > *').on('enter', el => {
    $(el).addClass('in-viewport');
  });

  $(window).on('beforeunload', function(event){
    let $activeElement = $(event.target.activeElement);
    let href = $activeElement.attr('href');

    if (href.includes('tel:') || href.includes('mailto:')) {
      return null;
    }

    $('body').addClass('close');
  });
})();



$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  
  var slider = new slate.Sections();
  sections.register('slider', theme.Slider);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});
